import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    meta: {
      title: '首页',
    },
  },
  {
    path: '/course',
    name: 'Course',
    component: () =>
      import(/* webpackChunkName:"course" */ '../views/Course/Course.vue'),
    meta: {
      title: '课程',
    },
  },
  {
    path: '/course/:id',
    name: 'CourseDetails',
    component: () =>
      import(
        /* webpackChunkName:"course" */ '../views/Course/CourseDetails.vue'
      ),
    meta: {
      title: '课程详情',
    },
  },
  {
    path: '/course/play/:id',
    name: 'CoursePlay',
    component: () =>
      import(/* webpackChunkName:"course" */ '../views/Course/CoursePlay.vue'),
    meta: {
      title: '课程播放',
    },
  },
  {
    path: '/study',
    name: 'Study',
    component: () =>
      import(/* webpackChunkName:"study" */ '../views/Layouts/StudyLayout.vue'),
    children: [
      {
        path: '/study/course',
        name: 'StudyCourse',
        component: () =>
          import(/* webpackChunkName:"study" */ '../views/Study/Course.vue'),
        meta: {
          title: '我的课程',
        },
      },
      {
        path: '/study/exam',
        name: 'StudyExam',
        component: () =>
          import(/* webpackChunkName:"study" */ '../views/Study/Exam.vue'),
        meta: {
          title: '我的考试',
        },
      },
      {
        path: '/study/live',
        name: 'StudyLive',
        component: () =>
          import(/* webpackChunkName:"study" */ '../views/Study/Live.vue'),
        meta: {
          title: '我的直播',
        },
      },
      {
        path: '/study/trainclass',
        name: 'StudyTrainClass',
        component: () =>
          import(
            /* webpackChunkName:"study" */ '../views/Study/TrainClass.vue'
          ),
        meta: {
          title: '我的专题',
        },
      },
      {
        path: '/study/questionnaire',
        name: 'StudyQuestionnaire',
        component: () =>
          import(
            /* webpackChunkName:"study" */ '../views/Study/Questionnaire.vue'
          ),
        meta: {
          title: '问卷',
        },
      },
      {
        path: '/study/topic',
        name: 'StudyTopic',
        component: () =>
          import(/* webpackChunkName:"study" */ '../views/Study/Topic.vue'),
        meta: {
          title: '社区',
        },
      },
    ],
    meta: {
      name: 'StudyCourse',
    },
  },
  {
    path: '/exam/answer/:id',
    name: 'ExamAnswer',
    component: () =>
      import(/* webpackChunkName: "exam" */ '../views/Exam/Answer.vue'),
    meta: {
      title: '考试作答',
    },
  },
  {
    path: '/exam/ranking/:id',
    name: 'ExamRanking',
    component: () =>
      import(/* webpackChunkName: "exam" */ '../views/Exam/Ranking.vue'),
    meta: {
      title: '考试排行榜',
    },
  },
  {
    path: '/exam/record/:id',
    name: 'ExamRecord',
    component: () =>
      import(/* webpackChunkName: "exam" */ '../views/Exam/Record.vue'),
    meta: {
      title: '考试情况查询',
    },
  },
  {
    path: '/exam/wrong/:id',
    name: 'ExamWrong',
    component: () =>
      import(/* webpackChunkName: "exam" */ '../views/Exam/Wrong.vue'),
    meta: {
      title: '考试错题查询',
    },
  },
  {
    path: '/exam/statistics/:id',
    name: 'ExamStatistics',
    component: () =>
      import(/* webpackChunkName: "exam" */ '../views/Exam/Statistics.vue'),
    meta: {
      title: '答卷情况统计',
    },
  },
  {
    path: '/questionnaire/answer/:id',
    name: 'QuestionnaireAnswer',
    component: () =>
      import(
        /* webpackChunkName: "study" */ '../views/Study/QuestionnaireAnswer.vue'
      ),
    meta: {
      title: '问卷作答',
    },
  },
  {
    path: '/knowpoint',
    name: 'KnowPoint',
    component: () =>
      import(/* webpackChunkName: "know" */ '../views/Know/KnowPoint.vue'),
    meta: {
      title: '百科',
    },
  },
  {
    path: '/knowpoint/:id',
    name: 'KnowPointDetails',
    component: () =>
      import(
        /* webpackChunkName: "know" */ '../views/Know/KnowPointDetails.vue'
      ),
    meta: {
      title: '百科详情',
    },
  },
  {
    path: '/knowledge',
    name: 'Knowledge',
    component: () =>
      import(/* webpackChunkName: "know" */ '../views/Know/Knowledge.vue'),
    meta: {
      title: '资源',
    },
  },
  {
    path: '/knowledge/:id',
    name: 'KnowledgeDetails',
    component: () =>
      import(
        /* webpackChunkName: "know" */ '../views/Know/KnowledgeDetails.vue'
      ),
    meta: {
      title: '资源详情',
    },
  },
  {
    path: '/userknowledge',
    name: 'UserKnowledge',
    component: () =>
      import(
        /* webpackChunkName: "know" */ '../views/UserKnow/UserKnowledge.vue'
      ),
    meta: {
      title: '知识库',
    },
  },
  {
    path: '/userknowledge/:id',
    name: 'UserKnowledgeDetails',
    component: () =>
      import(
        /* webpackChunkName: "know" */ '../views/UserKnow/UserKnowledgeDetails.vue'
      ),
    meta: {
      title: '知识库详情',
    },
  },
  {
    path: '/live',
    name: 'Live',
    component: () =>
      import(/* webpackChunkName: "live" */ '../views/Live/Live.vue'),
    meta: {
      title: '直播',
    },
  },
  {
    path: '/live/:id',
    name: 'LiveDetails',
    component: () =>
      import(/* webpackChunkName: "live" */ '../views/Live/LiveDetails.vue'),
    meta: {
      title: '直播详情',
    },
  },
  {
    path: '/live/on/:id',
    name: 'LiveOnline',
    component: () =>
      import(/* webpackChunkName: "live" */ '../views/Live/LiveOnline.vue'),
    meta: {
      title: '直播中',
    },
  },
  {
    path: '/trainclass',
    name: 'TrainClass',
    component: () =>
      import(/* webpackChunkName: "train" */ '../views/Train/TrainClass.vue'),
    meta: {
      title: '专题',
    },
  },
  {
    path: '/trainclass/:id',
    name: 'TrainClassDetails',
    component: () =>
      import(
        /* webpackChunkName: "train" */ '../views/Train/TrainClassDetails.vue'
      ),
    meta: {
      title: '专题详情',
    },
  },
  {
    path: '/trainalbum',
    name: 'TrainAlbum',
    component: () =>
      import(/* webpackChunkName: "train" */ '../views/Train/TrainAlbum.vue'),
    meta: {
      title: '培训相册',
    },
  },
  {
    path: '/lecturer',
    name: 'Lecturer',
    component: () =>
      import(
        /* webpackChunkName: "lecturer" */ '../views/Lecturer/Lecturer.vue'
      ),
    meta: {
      title: '讲师风采',
    },
  },
  {
    path: '/lecturer/:id',
    name: 'LecturerDetails',
    component: () =>
      import(
        /* webpackChunkName: "lecturer" */ '../views/Lecturer/LecturerDetails.vue'
      ),
    meta: {
      title: '讲师详情',
    },
  },
  {
    path: '/lecturer/vote/:id',
    name: 'LecturerVote',
    component: () =>
      import(
        /* webpackChunkName: "lecturer" */ '../views/Lecturer/LecturerVote.vue'
      ),
    meta: {
      title: '讲师评选',
    },
  },
  {
    path: '/personal/center',
    name: 'PersonalCenter',
    component: () =>
      import(/* webpackChunkName:"personal" */ '../views/Personal/Center.vue'),
    meta: {
      title: '个人信息',
    },
  },
  {
    path: '/personal',
    name: 'Personal',
    component: () =>
      import(
        /* webpackChunkName: "personal" */ '../views/Layouts/PersonalLayout.vue'
      ),
    children: [
      {
        path: '/personal/study',
        name: 'PersonalStudy',
        component: () =>
          import(
            /* webpackChunkName:"personal" */ '../views/Personal/Study.vue'
          ),
        meta: {
          title: '培训档案',
        },
      },
      {
        path: '/personal/MyStudyScore',
        name: 'MyStudyScore',
        component: () =>
          import(
            /* webpackChunkName:"personal" */ '../views/Personal/MyStudyScore.vue'
          ),
        meta: {
          title: '我的学分',
        },
      },
      {
        path: '/personal/favorites',
        name: 'PersonalFavorites',
        component: () =>
          import(
            /* webpackChunkName:"personal" */ '../views/Personal/Favorites.vue'
          ),
        meta: {
          title: '我的收藏',
        },
      },
      {
        path: '/personal/favorites/:id',
        name: 'PersonalFavoritesDetails',
        component: () =>
          import(
            /* webpackChunkName:"personal" */ '../views/Personal/FavoritesDetails.vue'
          ),
        meta: {
          title: '我的收藏',
        },
      },
      {
        path: '/personal/integral',
        name: 'PersonalIntegral',
        component: () =>
          import(
            /* webpackChunkName:"personal" */ '../views/Personal/Integral.vue'
          ),
        meta: {
          title: '我的积分',
        },
      },
      {
        path: '/personal/order',
        name: 'PersonalOrder',
        component: () =>
          import(
            /* webpackChunkName:"personal" */ '../views/Personal/Order.vue'
          ),
        meta: {
          title: '兑换记录',
        },
      },
      {
        path: '/personal/address',
        name: 'PersonalAddress',
        component: () =>
          import(
            /* webpackChunkName:"personal" */ '../views/Personal/Address.vue'
          ),
        meta: {
          title: '我的地址',
        },
      },
      {
        path: '/personal/certificate',
        name: 'PersonalCertificate',
        component: () =>
          import(
            /* webpackChunkName:"personal" */ '../views/Personal/Certificate.vue'
          ),
        meta: {
          title: '我的证书',
        },
      },
      {
        path: '/personal/mytopic',
        name: 'PersonalMyTopic',
        component: () =>
          import(
            /* webpackChunkName:"personal" */ '../views/Personal/MyTopic.vue'
          ),
        meta: {
          title: '我的话题',
        },
      },
      {
        path: '/personal/MyNote',
        name: 'PersonalMyNote',
        component: () =>
          import(
            /* webpackChunkName:"personal" */ '../views/Personal/MyNote.vue'
          ),
        meta: {
          title: '我的笔记',
        },
      },
      {
        path: '/personal/MyNote/:id',
        name: 'PersonalMyNoteDetail',
        component: () =>
          import(
            /* webpackChunkName:"personal" */ '../views/Personal/MyNoteDetail.vue'
          ),
        meta: {
          title: '我的笔记',
        },
      },
    ],
    meta: {
      name: 'PersonalStudy',
    },
  },
  {
    path: '/personal/certificate/:id',
    name: 'PersonalCertificateDetails',
    component: () =>
      import(
        /* webpackChunkName:"certificate" */ '../views/Personal/CertificateDetails.vue'
      ),
    meta: {
      title: '证书详情',
    },
  },
  {
    path: '/message/center',
    name: 'MessageCenter',
    component: () =>
      import(/* webpackChunkName:"message" */ '../views/Message/Center.vue'),
    meta: {
      title: '消息中心',
    },
  },
  {
    path: '/mall',
    name: 'Mall',
    component: () =>
      import(/* webpackChunkName:"mall" */ '../views/Mall/Mall.vue'),
    meta: {
      title: '积分商城',
    },
  },
  {
    path: '/search',
    name: 'Search',
    component: () =>
      import(/* webpackChunkName:"search" */ '../views/Search.vue'),
    meta: {
      title: '搜索',
    },
  },
  {
    path: '/learningmap',
    name: 'LearningMap',
    component: () =>
      import(
        /* webpackChunkName:"learningmap" */ '../views/LearningMap/LearningMap.vue'
      ),
    meta: {
      title: '学习地图',
    },
  },
  {
    path: '/learningmap/path/:id',
    name: 'LearningMapPath',
    component: () =>
      import(
        /* webpackChunkName:"learningmap" */ '../views/LearningMap/LearningMapPath.vue'
      ),
    meta: {
      title: '学习地图',
    },
  },
  {
    path: '/learningmap/path/stage/:id',
    name: 'LearningMapDetails',
    component: () =>
      import(
        /* webpackChunkName:"learningmap" */ '../views/LearningMap/LearningMapDetails.vue'
      ),
    meta: {
      title: '学习地图',
    },
  },
  {
    path: '/topic',
    name: 'Topic',
    component: () =>
      import(/* webpackChunkName:"topic" */ '../views/Topic/Topic.vue'),
    meta: {
      title: '社区',
    },
  },
  {
    path: '/topic/:id',
    name: 'TopicDetails',
    component: () =>
      import(/* webpackChunkName:"topic" */ '../views/Topic/TopicDetails.vue'),
    meta: {
      title: '话题详情',
    },
  },
  {
    path: '/shitu/index',
    name: 'Shitu',
    component: () =>
      import(/* webpackChunkName:"shitu" */ '../views/Shitu/Index.vue'),
    meta: {
      title: '师徒系统',
    },
  },
  {
    path: '/shitu/apprentice/willmaster',
    name: 'ShituWillMaster',
    component: () =>
      import(
        /* webpackChunkName:"shitu" */ '../views/Shitu/Apprentice/WillMaster.vue'
      ),
    meta: {
      title: '选择师傅',
    },
  },
  {
    path: '/shitu/apprentice',
    name: 'ShituApprentice',
    component: () =>
      import(
        /* webpackChunkName:"shitu_apprentice" */ '../views/Layouts/ShituApprenticeLayout.vue'
      ),
    children: [
      {
        path: '/shitu/apprentice/log',
        name: 'ShituApprenticeLog',
        component: () =>
          import(
            /* webpackChunkName:"shitu_apprentice" */ '../views/Shitu/Apprentice/Log.vue'
          ),
        meta: {
          title: '徒弟日志',
        },
      },
      {
        path: '/shitu/apprentice/log/list',
        name: 'ShituApprenticeLogList',
        component: () =>
          import(
            /* webpackChunkName:"shitu_apprentice" */ '../views/Shitu/Apprentice/LogList.vue'
          ),
        meta: {
          title: '徒弟日志',
        },
      },
      {
        path: '/shitu/apprentice/communication',
        name: 'ShituApprenticeCommunication',
        component: () =>
          import(
            /* webpackChunkName:"shitu_apprentice" */ '../views/Shitu/Apprentice/Communication.vue'
          ),
        meta: {
          title: '师徒沟通',
        },
      },
      {
        path: '/shitu/apprentice/task',
        name: 'ShituApprenticeTask',
        component: () =>
          import(
            /* webpackChunkName:"shitu_apprentice" */ '../views/Shitu/Apprentice/Task.vue'
          ),
        meta: {
          title: '师徒任务',
        },
      },
      {
        path: '/shitu/apprentice/master',
        name: 'ShituApprenticeMaster',
        component: () =>
          import(
            /* webpackChunkName:"shitu_apprentice" */ '../views/Shitu/Apprentice/Master.vue'
          ),
        meta: {
          title: '我的师傅',
        },
      },
    ],
    meta: {
      name: 'ShituApprenticeLog',
    },
  },
  {
    path: '/shitu/master',
    name: 'ShituMaster',
    component: () =>
      import(
        /* webpackChunkName:"shitu_master" */ '../views/Layouts/ShituMasterLayout.vue'
      ),
    children: [
      {
        path: '/shitu/master/apprentice',
        name: 'ShituMasterApprentice',
        component: () =>
          import(
            /* webpackChunkName:"shitu_master" */ '../views/Shitu/Master/Apprentice.vue'
          ),
        meta: {
          title: '我的徒弟',
        },
      },
      {
        path: '/shitu/master/apprentice/:id',
        name: 'ShituMasterApprenticeDetails',
        component: () =>
          import(
            /* webpackChunkName:"shitu_master" */ '../views/Shitu/Master/ApprenticeDetails.vue'
          ),
        meta: {
          title: '我的徒弟',
        },
      },
      {
        path: '/shitu/master/task',
        name: 'ShituMasterTask',
        component: () =>
          import(
            /* webpackChunkName:"shitu_master" */ '../views/Shitu/Master/Task.vue'
          ),
        meta: {
          title: '师徒任务',
        },
      },
      {
        path: '/shitu/master/apprentice/task/:id',
        name: 'ShituMasterApprenticeTask',
        component: () =>
          import(
            /* webpackChunkName:"shitu_master" */ '../views/Shitu/Master/ApprenticeTask.vue'
          ),
        meta: {
          title: '师徒任务',
        },
      },
      {
        path: '/shitu/master/task/:id',
        name: 'ShituMasterTaskDetails',
        component: () =>
          import(
            /* webpackChunkName:"shitu_master" */ '../views/Shitu/Master/TaskDetails.vue'
          ),
        meta: {
          title: '师徒任务详情',
        },
      },
      {
        path: '/shitu/master/apprentice/log/:id',
        name: 'ShituMasterLog',
        component: () =>
          import(
            /* webpackChunkName:"shitu_master" */ '../views/Shitu/Master/Log.vue'
          ),
        meta: {
          title: '徒弟日志',
        },
      },
      {
        path: '/shitu/master/apprentice/communication/:id',
        name: 'ShituMasterCommunication',
        component: () =>
          import(
            /* webpackChunkName:"shitu_master" */ '../views/Shitu/Master/Communication.vue'
          ),
        meta: {
          title: '师徒沟通',
        },
      },
    ],
    meta: {
      name: 'ShituMasterApprentice',
    },
  },
  {
    path: '*',
    redirect: { name: 'Home' },
  },
];

const router = new VueRouter({
  mode: 'history',
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to: any, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = 'ITS学习中心 - ' + to.meta.title;
  }
  if (to.meta.name) {
    next({ name: to.meta.name });
  } else {
    next();
  }
});

export default router;
